export default __webpack_public_path__ + "bb96f27918d0cb161472f5fe447242d3.svg";